export async function sleep(duration = 100): Promise<boolean> {
    return new Promise(resolve => {
        setTimeout(() => resolve(true), duration)
    })
}
export default sleep